const personalGames = [
    {   
        gameBanner: 'car-tuning', 
        gameName: 'Car Tuning', 
        releaseYear: 'Janeiro 2024', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Car-Tuning',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/car-tuning',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/9611512?color=333333',
        itchWidth: '1000',
        itchHeight: '590',
    },
    {   
        gameBanner: 'cinema', 
        gameName: 'Cinema', 
        releaseYear: 'Julho 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/First-Person-Cinema',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/cinema',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'cooking', 
        gameName: 'Cooking Rush', 
        releaseYear: 'Junho 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Cooking-Rush',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/cooking-rush',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/8322582?color=e9a99b',
        itchWidth: '960',
        itchHeight: '580',
    },
    {   
        gameBanner: 'mine', 
        gameName: 'Minesweeper', 
        releaseYear: 'Maio 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Minesweeper',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/minesweeper',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/7958955?color=808c5b',
        itchWidth: '800',
        itchHeight: '620',
    },
    {   
        gameBanner: 'stardew', 
        gameName: 'The Little Stardew Sims', 
        releaseYear: 'Março 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/The-Little-Stardew-Sims',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/the-little-stardew-sims',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/7578643?color=9b7147',
        itchWidth: '1000',
        itchHeight: '660',
    },
    {
        gameBanner: 'pong', 
        gameName: 'Pong', 
        releaseYear: 'Fevereiro 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/First-Person-Cinema',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/cinema',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://jerffesonj.github.io/Pong/',
        itchWidth: '1000',
        itchHeight: '620',
    },
    {   
        gameBanner: 'pirate', 
        gameName: 'Pirate 2D', 
        releaseYear: 'Fevereiro 2023', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Pirate-2D-Shooter',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/pirate-2d',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/7374092?color=87d8e9',
        itchWidth: '980',
        itchHeight: '620',
    },
    {   
        gameBanner: 'space', 
        gameName: 'Space Invaders', 
        releaseYear: 'Dezembro 2022', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/space-invaders',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/space-invaders',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/7418797?color=3d2f3f',
        itchWidth: '980',
        itchHeight: '620',
    },
    {   
        gameBanner: 'resident', 
        gameName: 'Resident Evil Clone', 
        releaseYear: 'Dezembro 2022', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Resident-Evil-Clone',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/resident-evil-clone',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: 'https://itch.io/embed-upload/6946068?color=00000f',
        itchWidth: '980',
        itchHeight: '660',
    },
    {   
        gameBanner: 'supapo', 
        gameName: 'Supapo', 
        releaseYear: 'Julho 2020', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Space-Invaders',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/supapo',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'lugar', 
        gameName: 'Um Lugar Seguro', 
        releaseYear: 'Janeiro 2019', 
        releaseState: '', 
        company: '',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: 'https://github.com/jerffesonj/Um-Lugar-Seguro',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/um-lugar-seguro',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
];
  
  export default personalGames;